module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon5.b58c3074.png";